import { StyleSheet } from '@rexlabs/styling';
export default StyleSheet({
  container: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  disabled: {
    cursor: 'default',
    opacity: 0.6,
    filter: 'grayscale(100%)'
  },
  prefix: {
    cursor: 'default'
  },
  input: {
    position: 'absolute',
    clipPath: 'inset(0)',
    opacity: '0',
    '& + label': {
      position: 'relative',
      display: 'inline-block',
      height: '1rem',
      width: '1rem',
      margin: '0.7rem',
      flexShrink: '0',
      borderRadius: '100%',
      backgroundColor: 'transparent',
      border: '0.05rem solid lightgrey',
      cursor: 'pointer',
      transition: "background-color 200ms ease-in,\n                   transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      '&:before': {
        position: 'absolute',
        content: '""',
        top: '45%',
        left: '50%',
        height: '0.4rem',
        width: '0.2rem',
        cursor: 'inherit',
        opacity: '0',
        transform: 'translate(-50%, -50%) rotate(45deg)',
        transformOrigin: '50% 50%',
        borderBottom: '0.02rem solid darkgrey',
        borderRight: '0.02rem solid darkgrey',
        transition: 'opacity 200ms ease-in'
      },
      '&:after': {
        position: 'absolute',
        content: '""',
        top: '-25%',
        left: '-25%',
        height: '150%',
        width: '150%',
        cursor: 'inherit'
      }
    },
    '&:checked + label': {
      backgroundColor: 'lightgrey',
      transition: "background-color 200ms ease-in,\n                   transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      '&:before': {
        opacity: '1',
        transition: 'opacity 200ms ease-in'
      }
    }
  },
  label: {
    display: 'inline-block',
    flexGrow: '1',
    cursor: 'pointer'
  },
  suffix: {
    cursor: 'default'
  }
});